export const categoryFilters = {
    computed: {
        /**
     * For these categories, we need to filter out the selected one in the primary list
     */
    filteredPrimaryCategories() {
        const secondary = this.formData.categories;
        if (!secondary || secondary.length < 1) {
          return this.$store.state.categories.categories;
        }
  
        //as additional is an array, we need to
        return this.$store.state.categories.categories.filter(cat => !secondary.includes(cat));
    
      },
      filteredAdditionalCategories() {
        const primary = this.formData.primary_category;
        if (!primary) {
          return this.$store.state.categories.categories;
        }
        return this.$store.state.categories.categories.filter(
          cat => cat.id != primary.id
        );
      },
    },
}